export default __webpack_public_path__ + "static/media/tete5.3cbacb95.png";